import { useEffect } from "react";
import {
  getSupabase,
  supabasePublic,
} from "../../../../components/supabaseClient";
import { parseAudioPeriodicBackupSettings } from "../../services/externalRecordingService";

/**
 * Loads mic preference, tenant schema, ai_recap_enabled, and backup interval from Supabase.
 */
export function UserPreferencesLoader({
  setPreferredMicDeviceId,
  setUserSchemaName,
  setAiRecapEnabled,
  setAudioBackupIntervalMs,
  setCopilotEnabled,
  onLoaded,
}) {
  useEffect(() => {
    (async () => {
      try {
        const supabase = await getSupabase();
        const {
          data: { user },
        } = await supabase.auth.getUser();
        if (!user) return;
        const { data: userData } = await supabase
          .from("users")
          .select("preferred_mic_device_id, schema, copilot_enabled, role")
          .eq("id", user.id)
          .single();
        if (userData?.schema) {
          const schema = userData.schema.includes(",")
            ? userData.schema.split(",")[0].trim()
            : userData.schema;
          setUserSchemaName(schema || "public");
        }
        if (userData?.preferred_mic_device_id) {
          setPreferredMicDeviceId(userData.preferred_mic_device_id);
        }
        console.log("🎤 [COPILOT-DEBUG] UserPreferencesLoader role/cflag:", {
          roleRaw: userData?.role || null,
          normalizedRoles: String(userData?.role || "")
            .toLowerCase()
            .split(",")
            .map((r) => r.trim())
            .filter(Boolean),
          copilotEnabledFromDb: userData?.copilot_enabled === true,
          paywallBypassActive: true,
        });
        // Stripe paywall removed (2026-06-25, Brett). Every user gets the
        // premium Copilot unconditionally.
        setCopilotEnabled(true);
        if (userData?.schema) {
          const pubClient = await supabasePublic();
          const schema = userData.schema.includes(",")
            ? userData.schema.split(",")[0].trim()
            : userData.schema;
          const { data: settings } = await pubClient
            .from("schema_settings")
            .select("ai_recap_enabled, audio_periodic_backup")
            .eq("schema_name", schema)
            .single();
          if (settings && settings.ai_recap_enabled !== undefined) {
            setAiRecapEnabled(settings.ai_recap_enabled ?? true);
          }
          const periodic = parseAudioPeriodicBackupSettings(
            settings?.audio_periodic_backup,
          );
          setAudioBackupIntervalMs(periodic.intervalMs);
        }
      } catch (err) {
        console.warn("⚠️ Could not load user preferences:", err.message);
      } finally {
        if (typeof onLoaded === "function") {
          onLoaded();
        }
      }
    })();
  }, [
    setPreferredMicDeviceId,
    setUserSchemaName,
    setAiRecapEnabled,
    setAudioBackupIntervalMs,
    setCopilotEnabled,
    onLoaded,
  ]);

  return null;
}
